import { Loader2 } from "lucide-react";
import { cn } from "../lib/cn";

export function Spinner({ className }: { className?: string }) {
  return (
    <Loader2
      className={cn("size-5 animate-spin text-violet-300", className)}
      aria-hidden
    />
  );
}

export function FullPageLoader({ label = "Загрузка…" }: { label?: string }) {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3">
      <Spinner className="size-6" />
      <p className="text-[13px] text-zinc-500">{label}</p>
    </div>
  );
}
